export default __webpack_public_path__ + "static/media/sato.d7c51d64.jpg";